<span class="toggle" (click)="toggle()">
    <i class="bullet" [ngClass]="{'bullet--enabled': enabled}"></i>
</span>
@if (showLabel) {
<span class="label">{{ enabled ? 'Aan' : 'Uit' }}</span>
}
